import _ from 'underscore';
import SystemDialogService from '../../../../shared/services/systemDialogService.js';
import stammdatenService from '../services/stammdatenService.js';
import systemNachrichtService from '../services/systemNachrichtService.js';
import { collectValues, displayArray, neueArrayRow, resetDialogInput } from '../util.js';
import { updateDebounceUnternehmen } from './verwaltung.js';
import { wendeListenSucheAn } from '../listenSuche.js';

window.myHandlers = window.myHandlers || {};
window.myHandlers.confirmNeueQualifikationDialog = confirmNeueQualifikationDialog;
window.myHandlers.neueQualifikation = neueQualifikation;
window.myHandlers.speichereQuali = speichereQuali;
window.myHandlers.editQualiBeschreibung = editQualiBeschreibung;
window.myHandlers.confirmQualiBeschreibung = confirmQualiBeschreibung;

async function ladeQualifikationen(unternehmen) {
	const sortedQualis = unternehmen.Qualifikationen.sort((a, b) => {
		// Leere Strings am Ende der Liste
		if (a.Qualifikationsnummer === null && b.Qualifikationsnummer === null) return 0;
		if (a.Qualifikationsnummer === null) return 1;
		if (b.Qualifikationsnummer === null) return -1;
		// Sortiere numerisch
		return a.Qualifikationsnummer - b.Qualifikationsnummer;
	});
	displayArray(sortedQualis, 'qu-');
	wendeListenSucheAn('qu-');
	// Indikator setzen, ob bereits eine Tätigkeitsbeschreibung hinterlegt ist
	sortedQualis.forEach((quali) => {
		const zeile = document.getElementById(`qu-${quali._id}`);
		if (zeile) {
			setBeschreibungIndikator(zeile.querySelector('.quali-beschreibung-button'), quali.Taetigkeitsbeschreibung);
		}
	});
}

/**
 * Markiert den Button, falls für die Qualifikation bereits eine Beschreibung existiert.
 * @param {HTMLElement} button Beschreibung-Button der Zeile
 * @param {string} beschreibung Markdown Inhalt der Tätigkeitsbeschreibung
 */
function setBeschreibungIndikator(button, beschreibung) {
	if (!button) {
		return;
	}
	const hatBeschreibung = !_.isEmpty(beschreibung?.trim());
	button.classList.toggle('has-beschreibung', hatBeschreibung);
	button.title = hatBeschreibung ? 'Tätigkeitsbeschreibung bearbeiten' : 'Tätigkeitsbeschreibung hinzufügen';
}

/**
 * Schließt den Tätigkeitsbeschreibungsdialog mit Übernahme der Eingabe.
 */
function confirmQualiBeschreibung() {
	SystemDialogService.instance.confirm();
}

/**
 * Öffnet einen Markdown Editor in einem Dialog, um die Tätigkeitsbeschreibung der Qualifikation zu pflegen.
 * @param {HTMLElement} thisElement der angeklickte Beschreibung-Button
 */
async function editQualiBeschreibung(thisElement) {
	const zeile = thisElement.closest('.qu-zeile');
	const qualiID = zeile.id.split('-')[1];
	const unternehmen = await stammdatenService.holeUnternehmensdaten();
	const quali = unternehmen.Qualifikationen.find((qu) => qu._id === qualiID);
	if (!quali) {
		return;
	}
	document.getElementById('quali-beschreibung-titel').innerText = `Tätigkeitsbeschreibung: ${quali.BezeichnungNeutral}`;
	// Editor wird erst bei Bedarf geladen (toast-ui ist ein großes Modul)
	const { createMarkdownEditor } = await import('../services/editorService.js');
	const resultPromise = SystemDialogService.instance.displayAsync('quali-beschreibung-dialog');
	const editor = createMarkdownEditor(document.querySelector('#quali-beschreibung-editor'), quali.Taetigkeitsbeschreibung || '');
	const input = await resultPromise;
	const markdown = editor.getMarkdown();
	editor.destroy();
	if (!input.success) {
		return;
	}
	// Direkt am gecachten Objekt setzen, damit parallele Zeilen-Speicherungen die Beschreibung nicht überschreiben
	quali.Taetigkeitsbeschreibung = markdown;
	updateDebounceUnternehmen(unternehmen);
	setBeschreibungIndikator(thisElement, markdown);
}

function confirmNeueQualifikationDialog() {
	SystemDialogService.instance.confirm({
		BezeichnungNeutral: document.getElementById('neu-quali-neutral').value,
		BezeichnungWeiblich: document.getElementById('neu-quali-female').value,
		BezeichnungMaennlich: document.getElementById('neu-quali-male').value,
		Qualifikationsnummer: parseInt(document.getElementById('neu-quali-number').value, 10),
	});
}

// Click handler von neue Netto Be/Abzüge anlegen
async function neueQualifikation(prefix) {
	// Öffnen und Warten auf Input Dialog...
	const input = await SystemDialogService.instance.displayAsync('neu-quali-dialog');
	// vermeide leere Einträge
	if (!input.success) {
		return;
	}
	if (input.success && input.data.BezeichnungNeutral === '') {
		systemNachrichtService.zeigeKleineNachricht('Abbruch: Keine Bezeichnung angegeben.', '0');
		return;
	}
	// Wir schicken den neuen Bezug an den Server
	const response = await stammdatenService.erstelleQualifikation(input.data);
	if (!response) {
		return;
	}
	resetDialogInput('neu-quali-dialog');
	// Aktualisierung der Oberfläche
	const template = document.querySelector(`[${prefix}template]`);
	// Wir brauchen ein Referenzelement, wo wir die neuen Zeilen im HTML einfügen können
	const referenceElement = document.querySelector(`[${prefix}button]`);
	neueArrayRow(template, referenceElement, response, prefix);
	wendeListenSucheAn(prefix);
}

/**
 * Speichert die aktuelle Änderung der bearbeiteten Zeile
 * @param {HTMLElement} thisElement input Feld, das bearbeitet wurde
 */
async function speichereQuali(thisElement) {
	// Zeile ist der parent des input elements
	const zeile = thisElement.parentNode;
	// wir brauchen nur die ID, also schließen wir den prefix (qu-) aus.
	const zeileID = zeile.id.split('-')[1];
	let unternehmen = await stammdatenService.holeUnternehmensdaten();
	// Wir benutzen vorsichtshalber eine Kopie, damit wir nicht später Inkonsitenzen bei einem Fehler haben
	unternehmen = JSON.parse(JSON.stringify(unternehmen));
	const quali = unternehmen.Qualifikationen.find((qu) => qu._id === zeileID);
	if (!quali) {
		// Lohnart ist nicht im Unternehmen findbar...
		return;
	}
	collectValues(quali, 'qu-', zeile);
	updateDebounceUnternehmen(unternehmen);
}

export {
	ladeQualifikationen
};
